export type ScheduleEntry = { id: string; title: string; start: string; end: string };
export function validScheduleDate(value: unknown): value is string {
  return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(value)) && new Date(value).toISOString().slice(0, 10) === value;
}
export function validateScheduleEntry(value: any): ScheduleEntry {
  if (!value || typeof value.id !== 'string' || !/^[a-zA-Z0-9-]{1,80}$/.test(value.id) || typeof value.title !== 'string' || !value.title.trim() || value.title.length > 120 || !validScheduleDate(value.start) || !validScheduleDate(value.end) || value.end < value.start) throw new Error('Enter a job name and valid start and end dates.');
  return { id: value.id, title: value.title.trim(), start: value.start, end: value.end };
}
export function readSchedule(value: unknown): ScheduleEntry[] {
  if (!Array.isArray(value)) return [];
  return value.slice(0, 500).flatMap(v => { try { return [validateScheduleEntry(v)]; } catch { return []; } });
}
export function schedulesOverlap(a: Pick<ScheduleEntry, 'start'|'end'>, b: Pick<ScheduleEntry, 'start'|'end'>) { return a.start <= b.end && b.start <= a.end; }
